<template>
  <el-dialog
    title="Thêm giao dịch cho khách"
    :visible.sync="dialogAddTransactionVisible"
    :close-on-click-modal="false"
    width="1100px"
    append-to-body
  >
    <div class="das-info-title">Thông tin khách</div>
    <InfoList :columns="5">
      <template v-for="item in transactionDialogInfo">
        <template>
          <InfoListLabel :key="item.label">{{ item.label }}</InfoListLabel>
          <InfoListValue :key="item.value" style="width: 120px">{{
            item.value
          }}</InfoListValue>
        </template>
      </template>
    </InfoList>
    <validation-observer ref="formValidator">
      <div class="das-form-container">
        <div class="das-form-group border-bottom mt-10">
          <div class="das-form-group-title">Thông tin giao dịch</div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="column">
                <div class="das-form-input mb-10">
                  <div class="label">Ngày giao dịch</div>
                  <validation-provider rules="required" name="Ngày giao dịch">
                    <CalendarSelect
                      v-model="transactionInfoForCustomer.transDate"
                      mode="date"
                      :min-max="{
                        min: data?.arrive_date,
                        max: data?.depart_date
                      }"
                    />
                  </validation-provider>
                </div>
                <!-- <div class="das-form-input">
                  <div class="label">Tham chiếu</div>
                  <input
                    v-model="transactionInfoForCustomer.invoiceNum"
                    v-numeric-only
                    type="number"
                  />
                </div> -->
              </div>
            </div>
            <div class="das-form-col col-4">
              <validation-provider rules="required" name="Trang giao dịch">
                <div class="das-form-input">
                  <div class="label required">Trang giao dịch</div>
                  <el-select
                    v-model="transactionInfoForCustomer.transPageId"
                    placeholder=""
                  >
                    <el-option
                      v-for="item1 in allTranPages"
                      :key="item1.id"
                      :label="`${item1.code} - ${item1.desc}`"
                      :value="item1.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">Ghi chú</div>
                <textarea v-model="transactionInfoForCustomer.note" :rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>

    <div class="mt-10" style="height: 300px">
      <GridVx
        ref="dialogTransactionGrid"
        :columns="dialogTransacCols"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="dialogTransacRows"
        :context="context"
        :suppress-row-click-selection="true"
        class="agGrid"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogAddTransactionVisible = false"
        >
          {{ $t('button.close') }}
        </button>
        <button class="btn primary small" @click="submitRoomTransaction">
          {{ $t('button.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import {
  CellHeaderAddIcon,
  CellRenderSelect,
  CellRenderTextInput,
  CellRenderDeleteIcon,
  CellRenderCurrencyInput,
  CellRenderSelectWithSearchTable
} from '@/utils/cellRenders'
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

import { getCodeBase } from '@/api/common/code_base'

import { getSpecialServiceTransApi } from '@/api/Service_Policy/specialService'
import { addMultiRoomTransaction } from '@/api/cashier_service/postTransaction'
import { h } from 'vue'

export default {
  components: {
    CellHeaderAddIcon,
    CellRenderSelect,
    CellRenderTextInput,
    CellRenderDeleteIcon,
    CellRenderSelectWithSearchTable,
    CellRenderCurrencyInput,
    DasButton,
    CalendarSelect
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      context: null,
      transactionDialogInfo: [],
      // params for submit add transaction
      transactionInfoForCustomer: {
        subBookingGroupId: null,
        transDate: null,
        invoiceNum: null,
        transPageId: null,
        note: null
      },
      dialogTransacRows: [
        {
          trans_page: null,
          transaction_desc: null,
          booking_code: null,
          amountExcludeTax: null,
          service_fee: null,
          feeAmount: null,
          tax: null,
          taxAmount: null,
          money: null
        }
      ],

      // rows
      transOptions: []
    }
  },
  computed: {
    dialogAddTransactionVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    allTranPages() {
      return this.$store.getters['allTranPages']
    },

    dialogTransacCols() {
      return [
        // {
        //   headerName: this.$t('grid.column.transactionPage'),
        //   field: 'trans_page',
        //   cellRenderer: 'CellRenderSelect',
        //   cellRendererParams: () => {
        //     return {
        //       // allTranPageOptions
        //       options: this.allTranPages.map(item => {
        //         return {
        //           label: item.code,
        //           value: item.id
        //         }
        //       }),
        //       value: this.allTranPages[0]['id'],
        //       refName: 'trans_page'
        //     }
        //   },
        //   minWidth: 100
        // },
        {
          headerName: this.$t('grid.column.transaction'),
          field: 'transaction_desc',
          width: 200
        },
        {
          headerName: this.$t('grid.column.subTransaction'),
          field: 'booking_code',
          cellRenderer: 'CellRenderSelectWithSearchTable',
          cellRendererParams: params => ({
            indexField: 'sub_transaction_id',
            searchFields: ['transaction_id_desc', 'sub_transaction_id_desc'],
            rows: this.transOptions,
            columns: [
              {
                headerName: this.$t('grid.column.transaction'),
                field: 'transaction_code',
                tooltipValueGetter: params =>
                  `${params.data.transaction_code} - ${params.data.transaction_desc}`,
                cellRenderer: params =>
                  `${params.data.transaction_code} - ${params.data.transaction_desc}`,
                // cellClass: "grid-cell-centered",
                flex: 1
              },
              {
                headerName: this.$t('grid.column.subTransaction'),
                tooltipValueGetter: params =>
                  `${params.data.sub_transaction_code} - ${params.data.sub_transaction_desc}`,
                cellRenderer: params =>
                  `${params.data.sub_transaction_code} - ${params.data.sub_transaction_desc}`,
                field: 'sub_transaction_code',
                // cellClass: "grid-cell-centered",
                flex: 1
              }
            ],
            selectedIndexFieldValue: params.data.sub_transaction_id,
            scopedSlotsValue: ({ selectedValue: selectedData }) => {
              return h('span', [
                selectedData?.sub_transaction_code,
                ' - ',
                selectedData?.sub_transaction_desc
              ])
            },
            // inputRendererParams: {
            //   tag: 'span',
            //   textArray: [
            //     selectedData?.sub_transaction_code,
            //     ' - ',
            //     selectedData?.sub_transaction_desc
            //   ]
            // },
            dropdownWidth: 400,
            colName: 'sub_transaction_desc'
          })
        },
        {
          headerName: this.$t('grid.column.amountExcludeTax'),
          field: 'amountExcludeTax',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: this.$t('grid.column.feePercent'),
          field: 'service_fee',
          width: 100
        },
        {
          headerName: this.$t('grid.column.feeAmount'),
          field: 'feeAmount',
          valueGetter: params => {
            return Number(params.data?.feeAmount).toLocaleString('en') || null
          },
          width: 150
        },
        {
          headerName: this.$t('grid.column.taxPercent'),
          field: 'tax',
          width: 100
        },
        {
          headerName: this.$t('grid.column.taxAmount'),
          field: 'taxAmount',
          valueGetter: params => {
            return Number(params.data?.taxAmount).toLocaleString('en') || null
          },
          width: 150
        },
        {
          headerName: this.$t('grid.column.amountIncludeTax'),
          field: 'money',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'dialogTransacCols'
            }
          }
        }
      ]
    }
  },
  watch: {
    async data(nv, ov) {
      if (nv) {
        this.transactionDialogInfo = [
          {
            label: 'Tên khách',
            value: `${nv?.last_name} ${nv?.first_name}`
          }
        ]
      }
    }
  },

  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  async mounted() {
    await this.fnGetSpecServiceOptions()
    await this.getAllTranPage()
  },

  methods: {
    // handle event
    onAddRowInGrid() {
      this.addTransactionRow()
    },
    addTransactionRow() {
      // const agGrid = this.$refs.dialogTransactionGrid.gridApi
      this.dialogTransacRows.push({
        trans_page: null,
        transaction_desc: null,
        booking_code: null,
        amountExcludeTax: null,
        service_fee: null,
        feeAmount: null,
        tax: null,
        taxAmount: null,
        money: null
      })
      // console.log('dialogTransacRows', this.dialogTransacRows)
      // agGrid.forEachNode(node => {
      //   node.setDataValue()
      // })
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.dialogTransacRows.splice(idx, 1)
    },
    resetTransactionDialog() {
      this.transactionInfoForCustomer.date = this.$moment(new Date()).format(
        'YYYY-MM-DD'
      )
      this.dialogTransacRows = [
        {
          trans_page: this.selected,
          transaction_desc: null,
          booking_code: null,
          amountExcludeTax: null,
          service_fee: null,
          feeAmount: null,
          tax: null,
          taxAmount: null,
          money: null
        }
      ]
    },
    selectSearchTableChange(params, row, colName) {
      const index = params.rowIndex
      if (colName === 'sub_transaction_desc') {
        this.dialogTransacRows[index]['sub_transaction_id'] =
          row.sub_transaction_id
        // eslint-disable-next-line no-unused-vars
        const agGrid = this.$refs.dialogTransactionGrid.gridApi
        agGrid.forEachNode(node => {
          if (node.rowIndex === index) {
            node.setDataValue('transaction_desc', row.transaction_desc)
            node.setDataValue('service_fee', row.service_fee)
            // node.setDataValue('sub_transaction_id', row.sub_transaction_id)
            node.setDataValue('tax', row.tax)
            // Reset amount data
            node.setDataValue('amountExcludeTax', 0)
            node.setDataValue('money', 0)
          }
        })
        return
      }
    },
    SelectInputChange(colName, data, value) {
      // console.log('KIKI', colName, data, value)
      // const idx = data.rowIndex
      // this.dialogTransacRows[idx][colName] = value
    },
    changeCurrencyInput(params, value, colNm) {
      // amountExcludeTax change
      let feeAmount = 0
      let taxAmount = 0
      let money = 0
      let amountBeforeTax = 0
      if (colNm === 'amountExcludeTax' && value) {
        feeAmount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['service_fee'])
        taxAmount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['tax'])
        amountBeforeTax = value
        money = Number(value) + feeAmount + taxAmount
      }
      if (colNm === 'money' && value) {
        feeAmount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['service_fee'])
        taxAmount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['tax'])
        money = value
        amountBeforeTax = value - feeAmount - taxAmount
      }
      const agGrid = this.$refs.dialogTransactionGrid.gridApi
      agGrid.forEachNode(node => {
        if (node.rowIndex === params.rowIndex) {
          node.setDataValue('feeAmount', feeAmount)
          node.setDataValue('taxAmount', taxAmount)
          node.setDataValue('money', money)
          node.setDataValue('amountExcludeTax', amountBeforeTax)
        }
      })
    },

    // handle api call
    async getAllTranPage() {
      const data = await getCodeBase({
        p_code: 'TRANPAGE'
      })
      const allTranPages = data.data || []
      this.$store.dispatch('cashier/addAllTranPages', allTranPages)
    },
    async fnGetSpecServiceOptions() {
      const data = await getSpecialServiceTransApi({ transaction_group: 1 })
      this.transOptions = data.data.map(item => ({
        ...item,
        transaction_id_desc: `${item.transaction_id} - ${item.transaction_desc}`,
        sub_transaction_id_desc: `${item.sub_transaction_id} - ${item.sub_transaction_desc}`
      }))
    },

    async submitRoomTransaction() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const params = {
        ...this.transactionInfoForCustomer,
        subBookingGroupId: this.data?.sub_booking_group_id
      }
      await addMultiRoomTransaction(this.dialogTransacRows, params)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.dialogAddTransactionVisible = false
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
